module.exports = __webpack_public_path__ + "static/media/08_hero_tablet.aabc3d20.jpg";